var init_sidebar = function () {

  var header = $('header');
  var content = $(".post-single--tours-cat-field");
  var sidebar = $(".post-single--tours-cat-field .right-box");
  var sticked = $(".post-single--tours-cat-field .right-box > .inner");

  // サイドバーの位置
  var sidebar_top = sidebar.offset().top;
  // 固定するコンテンツの元々の位置
  var sticked_original_top = sticked.offset().top;
  // 固定するコンテンツの高さ
  var sticked_height = sticked.height();
  // ヘッダの高さ
  var header_height = 181;

  var update_sidebar = function () {

    var bottom_offset = 0;
    var ua = window.navigator.userAgent;
    if (ua.indexOf('Trident/') != -1) {
      bottom_offset = 10;
    }

    // 現在の位置
    var scrollTop = $(document).scrollTop();
    // メインコンテンツ最後尾
    var content_bottom = content.offset().top + content.height();

    if (scrollTop > (sidebar_top - header_height) && (scrollTop < (content_bottom - header_height - sticked_height - bottom_offset))) {
      //console.log( '1>' + scrollTop + ' / ' + (content_bottom - header_height - sticked_height - bottom_offset) + ' (cb:' + content_bottom + ' hh:' + header_height + ' sh:' + sticked_height + ' bo:' + bottom_offset + ')' );
      // 現在位置が、初期位置より下で、メインコンテンツ最後尾より上なら、画面上部にサイドバーを固定
      sticked.css({
        'position': 'fixed',
        'top': header_height + 'px',
        'width': sidebar.width()
      });

    } else if (scrollTop >= content_bottom - header_height - sticked_height - bottom_offset) {
      //console.log( '2>' + scrollTop + ' / ' + (content_bottom - header_height - sticked_height - bottom_offset) + ' (cb:' + content_bottom + ' hh:' + header_height + ' sh:' + sticked_height + ' bo:' + bottom_offset + ')' );
      // 現在位置がメインコンテンツ最後尾より下なら、メインコンテンツ最後尾にサイドバーを位置させる
      sticked.css({
        'position': 'absolute',
        'top': content_bottom - sticked_height - sidebar_top - bottom_offset + 'px',
        'width': sidebar.width()
      });

    } else {
      // 現在位置が初期位置より上なら、何もしない
      sticked.css({ 'position': 'static' });
    }

  }

  $(window).off('scroll risize').on('scroll resize', function () { // スクロールかリサイズ時
    update_sidebar();
  });

}

$(function ($) {
  var windowWidth = $(window).width();
  var windowSm = 600;

  if (windowWidth <= windowSm) {
    // nothing to do
  } else {
    init_sidebar();
  }
});
